import axios from 'axios';
import { handle_error } from 'components/DirectivoUnidad/Vacaciones/helper_function';
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import { AniosDatosSolicitud, CertificadoDescarga, DescargarCertificado, ID_CERTIFICADO_CALIFICACIONES_CENACAD, ID_CERTIFICADO_CONTRATACIONES_CIVILES, ID_CERTIFICADO_EVALUACIONINTEGRAL, ID_CERTIFICADO_MATERIAS_DICTADAS, ID_CERTIFICADO_ROLES_PAGO, ID_CERTIFICADO_TRABAJO, OpcionesContratacionesCiviles, parseEstado, parseTipoCertificado, SolicitudCertificado } from 'components/UsuarioGeneral/Solicitud Certificados/Solicitud_Certificados';
import { alertService } from 'components/Varios/alert_service';
import Cargando from 'components/Varios/Cargando';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import { authHeader, authHeaderWithToken } from 'helpers/auth-header';
import React, { useCallback, useEffect, useState } from 'react'
//Componentes
import {
    Row, Col, FormGroup, Label, Container, Input, Modal, ModalBody

} from 'reactstrap';
import { authenticationService } from 'services/authentication.service';
import X2JS from 'x2js';
//URL
import configData from "../../../config.json";
import { ModalSubirCertificado } from './ModalSubirCertificado';
import ModalVistaPrevia from './ModalVistaPrevia';
import TableSolicitudesCertificadoAnalista from './TableSolicitudesCertificadoAnalista';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import ModalAtenderCertificado from './ModalsTablaCertificados/ModalAtenderCertificado';
import { ResponseRequestGeneric } from 'components/Types/GeneralTypes';
import { hadleAxiosErrorResponse } from 'helpers/handle-response';
import { showAlertSwal } from '../AprobacionesSolicitudes/AprobacionSolicitudesTh';



const ERRORES_SOLICITUDESCERT_ANALISTAS = {
    solicitudes_emitidas_firmadas: "Ha ocurrido un inconveniente al tratar de obtener las solicitudes emitidas/firmadas",
    generar_certificado_error: "No ha sido posible tratar de generar el certificado"
}


export type InfoSolicitudCertificadosAnalista = {
    idsolcertth: number,
    idcertificadotipo: number,
    dirigido?: string,
    idpersonasolicita: number,
    estadosolicitud: string,
    fechasolicitud: Date,
    observaciones?: string,
    idcontrato?: string,
    cargocontrato?: string,
    nombres: string,
    nombreCertificado: string,
    idCertificadoth?: number,
    estadoCertificado?: string,
    datosSolicitudCertificado?: string,
    automatizado: boolean,
    numeroIdentificacion: string,
    analistaEmitio?: string,
    fechaFirma?: Date,
    personaFirma?: string,
    referencia?: string,
    fechaemisionanalista?: Date,
    rowVersion: number
}







export type datosRequestAnalista = {
    solicitudesPendientes: Array<InfoSolicitudCertificadosAnalista>,
    solicitudesEmitidasGuardadas: Array<InfoSolicitudCertificadosAnalista>
}






export type DatosSolicitudXML = {
    anioDesde?: number,
    anioHasta?: number,
    usarTodosLosAnios?: boolean,
    aniosListado?: number[],
    terminoAcademico?: string,
    cargoContrato?: string,
    incluirSueldo?: boolean,
    fechaDesde?: string,
    fechaHasta?: string,
    roles?: string[],
    incluirHonorarios?:boolean,
    incluirTipoContrato?:boolean,
    anioInicio?:number,
    anioFin?:number

}

export type RolesPagosXML = {
    Rol: string
}

export type DataSolicitudesCeritificadosTable = {
    tip: string,
    fecs: Date,
    dir?: string,
    obs?: string,
    nom: string,
    numeroIdentificacion: string,
    vp: DatosVistaPrevia,
    datossol?: DatosSolicitudXML,
    analista?: string,
    personafirma?: string,
    fechafirma?: Date,
    fechaanalistaemite?: Date,
    estc?: string,
    cert?: CertificadoDescarga,
    rowVersion: number


}

type RequestCertificado = {
    idSolicitudCertificado: number,
    idPersonaCertificado: number
    personafirma?: PersonalFirmaCertificado,
    encabezadodirigido?: string,
    concurrencyToken: number
}
export type DatosVistaPrevia = {
    idsolicitud: number,
    idtipocertificado: number,
    idpersona: number,
    identificacion: string,
    dirigido?: string,
    tieneDirigido: boolean,
    automatizado: boolean,
    nombrePersona?: string,
    nombreCertificado?: string,
    estadoCertificado?: string,
    referencia?: string,
    concurrencyToken: number,
    estadosolicitud: string
}


export type PersonalFirmaCertificado = {
    nombres: string,
    cargo: string,
    idpersona: number
}


type XmlInformacionContrato = {
    IdContrato: number,
    IdRegimenLaboral: number,
    IncluirSueldo: boolean
    Desglose: boolean

}

export type XmlSolicitudCertificadoLaboralNuevo = {
    // opcionesCertificadoLaboral: {
    //     Contrato:XmlInformacionContrato,
    // },
    Contrato: XmlInformacionContrato,
    Nombre: "Nuevo"

}

export type XmlSolicitudCertificadoLaboral1 = {
    // opcionesCertificadoLaboral: {
    //     IncluirSueldo:boolean
    // },
    IncluirSueldo: boolean,
    Nombre: "1"

}

export type DatosModalAtenderCertificado = {
    datosCertificado: DatosVistaPrevia,
}

type XmlSolicitudCertificadoLaboral = XmlSolicitudCertificadoLaboralNuevo | XmlSolicitudCertificadoLaboral1

const Is_Certificado_Nuevo = (datos: XmlSolicitudCertificadoLaboral): datos is XmlSolicitudCertificadoLaboralNuevo => {
    return (datos as XmlSolicitudCertificadoLaboralNuevo).Nombre === "Nuevo";
}

export function auxiliarParsearInfotoTable(info: InfoSolicitudCertificadosAnalista[], isDirectorTH: boolean = false) {
    var x2js = new X2JS();

    var datatabla: DataSolicitudesCeritificadosTable[] = []
    info.map((solic) => {

        var jsonObj: DatosSolicitudXML | undefined = undefined;
        if (solic.datosSolicitudCertificado) {

            var objeto: any = x2js.xml2js(solic.datosSolicitudCertificado)
            var valores: any

            switch (solic.idcertificadotipo) {
                case ID_CERTIFICADO_TRABAJO:
                    const posibleXmlObtenido: XmlSolicitudCertificadoLaboral = objeto;
                    if (Is_Certificado_Nuevo(posibleXmlObtenido)) {
                        const datosXml: XmlSolicitudCertificadoLaboralNuevo = posibleXmlObtenido;
                        jsonObj = {
                            incluirSueldo: datosXml.Contrato.IncluirSueldo,
                            cargoContrato: solic.idcontrato !== undefined && +solic.idcontrato > 0 ? solic.cargocontrato : undefined

                        }
                    }
                    else {
                        const datosXml: XmlSolicitudCertificadoLaboral1 = posibleXmlObtenido;
                        jsonObj = {
                            incluirSueldo: datosXml.IncluirSueldo,
                            cargoContrato: solic.idcontrato !== undefined && +solic.idcontrato > 0 ? solic.cargocontrato : undefined

                        }
                    }
                    break;

                case ID_CERTIFICADO_CONTRATACIONES_CIVILES:
                    
                    const datosXml: OpcionesContratacionesCiviles = objeto.OpcionesCertificadoContratacionesCiviles;
                    
                    jsonObj = {
                        incluirSueldo: datosXml.IncluirHonorarios,
                        anioInicio: +datosXml.AnioInicio,
                        anioFin:+datosXml.AnioFin,
                        incluirTipoContrato:datosXml.IncluirTipoContrato
                    }
                    break;

                case ID_CERTIFICADO_ROLES_PAGO:
                    var rolesNombres: string[] = [];
                    valores = objeto.opcionesRolesCertificados;
                    var rolesXML: RolesPagosXML[] | RolesPagosXML = valores.Roles.RolPagoCertificadoXml;

                    if (Array.isArray(rolesXML)) {
                        rolesNombres = rolesXML.map((v, i) => {
                            return v.Rol;
                        });
                    }
                    else {
                        rolesNombres.push(rolesXML.Rol);
                    }


                    jsonObj = {
                        fechaDesde: valores.FechaDesde,
                        fechaHasta: valores.FechaHasta,
                        roles: rolesNombres
                    }
                    break;

                default:
                    valores = objeto.datoscertificadoanio;
                    jsonObj = {
                        usarTodosLosAnios: valores.usarTodosLosAnios === "true",
                        anioDesde: valores.anioDesde ? +valores.anioDesde : undefined,
                        anioHasta: valores.anioHasta ? +valores.anioHasta : undefined,
                        terminoAcademico: valores.terminoAcademico ? valores.terminoAcademico : undefined,
                        cargoContrato: solic.idcontrato !== undefined && +solic.idcontrato > 0 ? solic.cargocontrato : undefined
                    }
                    break;
            }

        }
        else if (solic.idcontrato !== undefined && +solic.idcontrato > 0) {
            jsonObj = {
                cargoContrato: solic.cargocontrato
            }
        }

        if (isDirectorTH) {
            datatabla.push({
                fecs: solic.fechasolicitud,
                nom: solic.nombres,
                tip: solic.nombreCertificado,
                vp: {
                    idtipocertificado: solic.idcertificadotipo,
                    idsolicitud: solic.idsolcertth,
                    idpersona: solic.idpersonasolicita,
                    identificacion: solic.numeroIdentificacion,
                    dirigido: solic.dirigido ? solic.dirigido : undefined,
                    tieneDirigido: solic.dirigido ? true : false,
                    automatizado: solic.automatizado,
                    nombreCertificado: solic.nombreCertificado,
                    nombrePersona: solic.nombres,
                    estadoCertificado: solic.estadoCertificado,
                    referencia: solic.referencia,
                    concurrencyToken: solic.rowVersion,
                    estadosolicitud: solic.estadosolicitud
                },
                estc: parseEstado(solic.idcertificadotipo, solic.estadoCertificado, solic.estadosolicitud),
                dir: solic.dirigido,
                obs: solic.observaciones,
                datossol: jsonObj,
                numeroIdentificacion: solic.numeroIdentificacion,
                analista: solic.analistaEmitio,
                fechafirma: solic.fechaFirma,
                personafirma: solic.personaFirma,
                fechaanalistaemite: solic.fechaemisionanalista,
                cert: {
                    referencia: solic.referencia,
                    estadocertificado: solic.estadoCertificado,
                    idcertificado: solic.idCertificadoth,
                    certificadoAutomatizado: solic.automatizado,
                    nombreTipoCertificado: solic.nombreCertificado,
                    nombreSolicita: solic.nombres,
                    estadoSolicitud: solic.estadosolicitud,
                    idTipoCertificado: solic.idcertificadotipo,
                    analistaEmitio: solic.analistaEmitio ?? "",
                    fechaEmisionCertificado: solic.fechaemisionanalista !== undefined && solic.fechaemisionanalista !== null ? ObtenerFechaFromIsoFormat(solic.fechaemisionanalista.toString()) : "",
                    fechaSolicitudFormato: ObtenerFechaFromIsoFormat(solic.fechasolicitud.toString())
                },
                rowVersion: solic.rowVersion

            })
        }
        else {
            datatabla.push({
                fecs: solic.fechasolicitud,
                nom: solic.nombres,
                tip: solic.nombreCertificado,
                vp: {
                    idtipocertificado: solic.idcertificadotipo,
                    idsolicitud: solic.idsolcertth,
                    idpersona: solic.idpersonasolicita,
                    identificacion: solic.numeroIdentificacion,
                    dirigido: solic.dirigido ? solic.dirigido : undefined,
                    tieneDirigido: solic.dirigido ? true : false,
                    automatizado: solic.automatizado,
                    nombreCertificado: solic.nombreCertificado,
                    nombrePersona: solic.nombres,
                    estadoCertificado: solic.estadoCertificado,
                    referencia: solic.referencia,
                    concurrencyToken: solic.rowVersion,
                    estadosolicitud: solic.estadosolicitud
                },
                estc: parseEstado(solic.idcertificadotipo, solic.estadoCertificado, solic.estadosolicitud),
                dir: solic.dirigido,
                obs: solic.observaciones,
                datossol: jsonObj,
                numeroIdentificacion: solic.numeroIdentificacion,
                analista: solic.analistaEmitio,
                fechafirma: solic.fechaFirma,
                personafirma: solic.personaFirma,
                fechaanalistaemite: solic.fechaemisionanalista,
                rowVersion: solic.rowVersion
            })
        }

    })
    return datatabla
}


type PropsSolicitudesCertificadosAnalista = {
    urlConsulta: string
}

export default function SolicitudesCertificados(props: PropsSolicitudesCertificadosAnalista) {



    const [DataTableSolicitudes, setDataTableSolicitudes] = useState<DataSolicitudesCeritificadosTable[]>([])
    //TABLA DE CERITIFCADOS EMITIDOS/FIRMADOS
    const [DataTableSolicitudesEmitidasFirmadas, setDataTableSolicitudesEmitidasFirmadas] = useState<DataSolicitudesCeritificadosTable[]>([])
    const [loadingSolicEmitidasFirmadas, setloadingSolicEmitidasFirmadas] = useState<boolean>(false)
    const [anioSeleccionadoConsulta, setanioSeleccionadoConsulta] = useState<number>(-1);


    const [ElementoTablaSolicEmitFirm, setElementoTablaSolicEmitFirm] = useState<HTMLElement | undefined>(undefined)



    const [loading, setloading] = useState<boolean>(false);
    const [datosVistaPrevia, setdatosVistaPrevia] = useState<DatosVistaPrevia>({
        idsolicitud: -1,
        idtipocertificado: -1,
        idpersona: -1,
        identificacion: "",
        tieneDirigido: false,
        automatizado: false,
        concurrencyToken: 0,
        estadosolicitud: ""
    })
    const [urlVistaPrevia, seturlVistaPrevia] = useState<string>("")
    const [showModalVistaPrevia, setshowModalVistaPrevia] = useState<boolean>(false)
    const [showModalloading, setshowModalloading] = useState<boolean>(false)
    const [showModalSubirCertificado, setshowModalSubirCertificado] = useState<boolean>(false)

    const [opcionesPersonaFirma, setopcionesPersonaFirma] = useState<{ value: string, label: string }[]>([]);
    const [personaFirma, setpersonaFirma] = useState<PersonalFirmaCertificado>({ cargo: "", nombres: "", idpersona: -1 })
    const [personalFirma, setpersonalFirma] = useState<PersonalFirmaCertificado[]>([])

    const [actualizarVistaPrevia, setactualizarVistaPrevia] = useState<number>(-1)

    const [generarCertificado, setgenerarCertificado] = useState<number>(-1)
    const [encabezadoDirigido, setencabezadoDirigido] = useState<string>("")

    const [datosModalAtender, setdatosModalAtender] = useState<DatosModalAtenderCertificado | undefined>(undefined);

    const defaultStateModalRP: {
        showModal: boolean,
        idSolicitud: number
    } = {
        showModal: false,
        idSolicitud: -1
    }

    const [dataModalRolesPago, setdataModalRolesPago] = useState(defaultStateModalRP);



    const ObtenerSolicitudesCertificadosPendientes = async (datosUsuario: UserData, anio: number) => {
        setloading(true);

        const RUTA_SOLICITUDES_CERTIFICADOS_PENDIENTES = `${configData.SERVER_URL}${props.urlConsulta}/A/${anio}`;
        try {
            const respuesta = await axios.get(RUTA_SOLICITUDES_CERTIFICADOS_PENDIENTES, {
                headers:
                {
                    'Content-Type': 'application/json',
                    Authorization: `KEYESPOL ${datosUsuario?.token}`,

                }
            });

            var info: InfoSolicitudCertificadosAnalista[] = respuesta.data;
            setDataTableSolicitudes(auxiliarParsearInfotoTable(info));
            window.scrollTo({
                top: 0,
                behavior: "auto"
            });

        } catch (error) {
            // var error_any: any = error;
            // var number = handle_error(error_any);
            alertService.error("Ha ocurrido un inconveniente")
        }
        setloading(false);
        setdataModalRolesPago(defaultStateModalRP)
        setdatosModalAtender(undefined)
    }

    async function VerificarContratoCivilVigenteTieneActividades(datos: DatosVistaPrevia) {
        const identificacionUsuarioSolicita: string = datos.identificacion;

        const RUTA_CONSULTA_CIVIL_VIGENTE_CON_ACTIVIDADES = `${configData.SERVER_URL}GenerarCertificados/ActividadesContratoCivilVigente/${identificacionUsuarioSolicita}`;


        var respuesta: ResponseRequestGeneric<boolean> = {
            status: -1
        }

        try {
            const responseConsulta = await axios.get(RUTA_CONSULTA_CIVIL_VIGENTE_CON_ACTIVIDADES, {
                headers: authHeader()
            })


            respuesta = {
                status: responseConsulta.status,
                dataResponse: responseConsulta.data
            }


        } catch (error) {
            respuesta = hadleAxiosErrorResponse<boolean>(error);
        }

        if (respuesta.status === 200 && respuesta.dataResponse !== undefined && respuesta.dataResponse === false) {
            showAlertSwal("El contrato civil del usuario no tiene actividades asignadas", false)

        }


    }



    const ObtenerSolicitudesCertificadosEmitidasFirmadas = async (datosUsuario: UserData) => {
        setloadingSolicEmitidasFirmadas(true)
        try {
            const respuesta = await axios.get(configData.SERVER_URL + "SolicitudCertificados/Analista/SolicitudesEmitidasFirmadas/", {
                headers:
                {
                    'Content-Type': 'application/json',
                    Authorization: `KEYESPOL ${datosUsuario?.token}`,

                }
            });

            var info: InfoSolicitudCertificadosAnalista[] = respuesta.data;
            setDataTableSolicitudesEmitidasFirmadas(auxiliarParsearInfotoTable(info));

        } catch (error) {
            var error_any: any = error;
            var number = handle_error(error_any);
            var message = "Ha ocurrido un inconveniente inesperado"
            switch (number) {
                case -1 || number < 0:
                    break;
                case 409:
                    message = error_any.response.data
                    break;
                case 500:
                    message = ERRORES_SOLICITUDESCERT_ANALISTAS.solicitudes_emitidas_firmadas
                    break;
                case 401:
                    message = "No está autorizado a realizar dicha acción"
                    break;
                default:
                    break;
            }
            alertService.error(message)
        }
        setloadingSolicEmitidasFirmadas(false)

    }


    const ObtenerPDFCertificado = async (datosUsuario: UserData, idTipoCertificado: number, request: RequestCertificado) => {
        setshowModalloading(true);
        var ulrrequest = `GenerarCertificados/`;
        var certificadourl = ""
        switch (idTipoCertificado) {
            case ID_CERTIFICADO_TRABAJO:
                certificadourl = `CertificadoTrabajo`
                break;
            case ID_CERTIFICADO_EVALUACIONINTEGRAL:
                certificadourl = `CertificadoEvaluacionIntegral`
                break;
            case ID_CERTIFICADO_CALIFICACIONES_CENACAD:
                certificadourl = `CertificadoCalificacionesCenacad`
                break;
            case ID_CERTIFICADO_MATERIAS_DICTADAS:
                certificadourl = `CertificadoMateriasDictadas`
                break;
            case ID_CERTIFICADO_CONTRATACIONES_CIVILES:
                certificadourl += `CertificadoContratacionesCiviles`
                break;
            default:
                break;
        }

        ulrrequest += certificadourl;

        await fetch(configData.SERVER_URL + ulrrequest, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `KEYESPOL ${datosUsuario.token}`,

            },
            body: JSON.stringify(request)
        })
            .then(response => {
                response.blob()
                    .then(blob => {
                        let url = window.URL.createObjectURL(blob);
                        var file_object = new File([blob], "certificado");
                        seturlVistaPrevia(url);

                    });

            })

            .catch((error) => {
                var error_any: any = error;
                var status_code: number = handle_error(error_any);
                switch (status_code) {
                    case 0:
                        alertService.error("No se ha podido establecer contacto con el servidor");
                        break;
                    case 500:
                        alertService.error("Ha ocurrido un error inesperado");
                        break;
                    default:
                        alertService.error("Ha ocurrido un error desconocido");
                        break;
                }
                window.scrollTo({
                    top: 0,
                    behavior: "auto"
                });
            });



        setshowModalloading(false);

    }
    const GenerarCertificado = async (datosUsuario: UserData, idTipoCertificado: number, request: RequestCertificado) => {
        setshowModalloading(true);
        var ulrrequest = `GenerarCertificados/`;
        var certificadourl = "EmitirCertificado/"
        switch (idTipoCertificado) {
            case ID_CERTIFICADO_TRABAJO:
                certificadourl += `CertificadoTrabajo`
                break;
            case ID_CERTIFICADO_EVALUACIONINTEGRAL:
                certificadourl += `EvaluacionIntegral`
                break;
            case ID_CERTIFICADO_CALIFICACIONES_CENACAD:
                certificadourl += `CalificacionesCenacad`
                break;
            case ID_CERTIFICADO_MATERIAS_DICTADAS:
                certificadourl += `MateriasDictadas`
                break;
            case ID_CERTIFICADO_CONTRATACIONES_CIVILES:
                certificadourl += `ContratacionesCiviles`
                break;

            default:
                break;
        }

        ulrrequest += certificadourl;

        await fetch(configData.SERVER_URL + ulrrequest, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `KEYESPOL ${datosUsuario.token}`,

            },
            body: JSON.stringify(request)
        })
            .then(async response => {
                var status_code: number = response.status
                if (status_code !== 201 && status_code !== 200) {
                    var error_mensaje = await response.text();
                    switch (status_code) {
                        case 0:
                            alertService.error("No se ha podido establecer contacto con el servidor");
                            break;
                        case 500:
                            alertService.error("Ha ocurrido un error inesperado");
                            break;
                        case 409:
                            alertService.error(error_mensaje);
                            break;
                        default:
                            alertService.error("Ha ocurrido un error desconocido");
                            break;
                    }
                    window.scrollTo({
                        top: 0,
                        behavior: "auto"
                    });
                    HandleRespuestaErrorEmitirCertificado()

                }
                else {
                    var DatosSolicitudAtendida: SolicitudCertificado = await response.json();
                    HandleRespuestaEmitirCrearCertificado(DatosSolicitudAtendida, "Se ha generado el Certificado con éxito")
                }
            })

            .catch((error) => {
                var error_any: any = error;
                var status_code: number = handle_error(error_any);
                switch (status_code) {
                    case 0:
                        alertService.error("No se ha podido establecer contacto con el servidor");
                        break;
                    case 500:
                        alertService.error("Ha ocurrido un error inesperado");
                        break;
                    case 409:
                        alertService.error(error_any.response.data);
                        break;
                    default:
                        alertService.error("Ha ocurrido un error desconocido");
                        break;
                }
                window.scrollTo({
                    top: 0,
                    behavior: "auto"
                });
                HandleRespuestaErrorEmitirCertificado()
            });
        setshowModalloading(false);

    }

    const handleNotificarCertificado = async (idSolicitud: number) => {
        const url = configData.SERVER_URL + "GenerarCertificados/NotificarCertificadoRoles/" + idSolicitud;
        const datosUsuario: UserData = authenticationService.currentUserValue;
        if (datosUsuario === undefined) {
            alertService.error("No hay información del usuario disponible")
        }
        try {
            const respuesta = await axios.post(url, {},
                {
                    headers: authHeaderWithToken(datosUsuario.token)
                })
            alertService.success("Se ha notificado con exito al servidor sobre su certificado de roles de pago físico")

            return 1

        } catch (error) {
            alertService.error("Ha ocurrido un error al intentar notificar al servidor sobre su certificado de roles de pago físico")

        }
        return -1
    }



    const HandleRespuestaEmitirCrearCertificado = useCallback(
        async (DatosSolicitudAtendida: SolicitudCertificado, mensaje: string) => {
            const datosUsuario: UserData = authenticationService.currentUserValue;
            alertService.success(mensaje);
            ReiniciarModalCertificado()
            await ObtenerSolicitudesCertificadosPendientes(datosUsuario, anioSeleccionadoConsulta)
            window.scrollTo({
                top: 0,
                behavior: "auto"
            });
        },
        [anioSeleccionadoConsulta],
    )

    const HandleRespuestaAtenderCertificado = useCallback(
        async (mensaje: string) => {
            const datosUsuario: UserData = authenticationService.currentUserValue;
            alertService.success(mensaje);
            // ReiniciarModalCertificado()
            await ObtenerSolicitudesCertificadosPendientes(datosUsuario, anioSeleccionadoConsulta)

        },
        [anioSeleccionadoConsulta],
    )








    function HandleRespuestaErrorEmitirCertificado() {
        setshowModalVistaPrevia(false)
        setshowModalSubirCertificado(false)
        ReiniciarModalCertificado()
    }

    const ObtenerPersonasFirmanCertificado = async (datosUsuario: UserData) => {
        try {
            const respuesta = await axios.get(configData.SERVER_URL + "GenerarCertificados/DatosGenerarCertificado", {
                headers:
                {
                    'Content-Type': 'application/json',
                    Authorization: `KEYESPOL ${datosUsuario?.token}`,

                }
            });

            var info: PersonalFirmaCertificado[] = respuesta.data;
            if (info.length !== 0) {
                setpersonalFirma(info);
            }


        } catch (error) {

            alertService.error("Ha ocurrido un inconveniente")
        }

    }



    useEffect(() => {
        if (personalFirma.length !== 0) {
            var combo_firma: { value: string, label: string }[] = []
            personalFirma.map((val) => {
                combo_firma.push({
                    label: val.nombres + "-" + val.cargo,
                    value: val.idpersona.toString()
                })
            })
            setopcionesPersonaFirma(combo_firma);
            setpersonaFirma(personalFirma[0])
        }
    }, [personalFirma])


    useEffect(() => {

        if (showModalVistaPrevia && datosVistaPrevia.idpersona > 0 && datosVistaPrevia.idtipocertificado === ID_CERTIFICADO_CONTRATACIONES_CIVILES) {
            VerificarContratoCivilVigenteTieneActividades(datosVistaPrevia)
        }


    }, [showModalVistaPrevia, datosVistaPrevia])




    function ReiniciarModalCertificado() {
        setdatosVistaPrevia({
            idsolicitud: -1,
            idtipocertificado: -1,
            idpersona: -1,
            identificacion: "",
            dirigido: undefined,
            tieneDirigido: false,
            automatizado: false,
            concurrencyToken: 0,
            estadosolicitud: ""
        })
        setpersonaFirma({ cargo: "", idpersona: -1, nombres: "" })
        setactualizarVistaPrevia(-1)
        setgenerarCertificado(-1)
        seturlVistaPrevia("")
        setshowModalVistaPrevia(false)
        setencabezadoDirigido("")
        setshowModalSubirCertificado(false);
        setshowModalloading(false)
        document.body.classList.remove('modal-open')

    }



    function handleSelectChange(value: string, name: string) {
        try {
            var nombres_cargo: string[] = name.split("-")
            setpersonaFirma({
                cargo: nombres_cargo[1],
                idpersona: +value,
                nombres: nombres_cargo[0]
            })
        } catch (error) {
            alertService.error("Error al tratar de colocar opciones para Firmar");
        }


    }


    async function ObtenerAniosDisponiblesParaConsulta() {
        setloading(true);
        const datosUsuario: UserData = authenticationService.currentUserValue;

        try {
            const respuesta = await axios.get(configData.SERVER_URL + "SolicitudCertificados/Analista/YearsSolicitudes", {
                headers:
                {
                    'Content-Type': 'application/json',
                    Authorization: `KEYESPOL ${datosUsuario?.token}`,

                }
            });

            const listadoAniosParaConsulta: number[] = respuesta.data;

            if (listadoAniosParaConsulta.length >= 1) {
                setanioSeleccionadoConsulta(listadoAniosParaConsulta[0]);
            }



        } catch (error) {
            if (axios.isAxiosError(error) && error.response && error.response.data) {
                alertService.error(error.response.data);
            }
            else {
                alertService.error("Ha ocurrido un inconveniente al intentar obtener información sobre las solicitudes de certificados.")
            }

        }
        setloading(false);
    }

    // useEffect(() => {
    //     setloading(true)
    //     var datosUsuario = authenticationService.currentUserValue;
    //     if (datosUsuario) {
    //         ObtenerSolicitudesCertificadosPendientes(datosUsuario)
    //         // ObtenerSolicitudesCertificadosEmitidasFirmadas(datosUsuario)
    //         ObtenerPersonasFirmanCertificado(datosUsuario)
    //     }
    // }, [])

    useEffect(() => {
        if (anioSeleccionadoConsulta > -1) {
            const datosUsuario: UserData = authenticationService.currentUserValue;
            ObtenerSolicitudesCertificadosPendientes(datosUsuario, anioSeleccionadoConsulta);
            ObtenerPersonasFirmanCertificado(datosUsuario)

        }
    }, [anioSeleccionadoConsulta, props.urlConsulta])



    useEffect(() => {
        ObtenerAniosDisponiblesParaConsulta();
    }, [])


    async function RecargarVistaPrevia(datosVistaPrevia: DatosVistaPrevia) {
        const { idsolicitud, idtipocertificado, idpersona, automatizado, concurrencyToken } = datosVistaPrevia;
        var datosUsuario = authenticationService.currentUserValue;
        if (datosUsuario) {
            if (idpersona > 0) {
                await ObtenerPDFCertificado(datosUsuario, idtipocertificado, {
                    idPersonaCertificado: idpersona,
                    idSolicitudCertificado: idsolicitud,
                    personafirma: personalFirma[0],
                    encabezadodirigido: encabezadoDirigido,
                    concurrencyToken
                })
            }
        }
    }


    useEffect(() => {


        const { idsolicitud, idtipocertificado, idpersona, automatizado, concurrencyToken } = datosVistaPrevia;
        if (idsolicitud !== -1 && idtipocertificado !== -1 && automatizado) {
            var datosUsuario = authenticationService.currentUserValue;
            if (datosUsuario) {

                //Aqui es cuando la persona que actualiza la Vista Previa tambien indica quien firma
                if (actualizarVistaPrevia > -1) {
                    //
                    if (personaFirma.idpersona !== -1) {
                        ObtenerPDFCertificado(datosUsuario, idtipocertificado, {
                            idPersonaCertificado: idpersona,
                            idSolicitudCertificado: idsolicitud,
                            personafirma: personalFirma[0],
                            encabezadodirigido: encabezadoDirigido,
                            concurrencyToken
                        })
                    }
                }

                else {
                    ObtenerPDFCertificado(datosUsuario, idtipocertificado, {
                        idPersonaCertificado: idpersona,
                        idSolicitudCertificado: idsolicitud,
                        personafirma: personalFirma[0],
                        concurrencyToken
                    })
                }


            }
        }
        else if (idsolicitud !== -1 && idtipocertificado !== -1 && !automatizado) {
            setshowModalSubirCertificado(true)
        }


    }, [datosVistaPrevia.idsolicitud, datosVistaPrevia.idtipocertificado, actualizarVistaPrevia])


    useEffect(() => {
        var datosUsuario = authenticationService.currentUserValue;

        if (datosUsuario) {
            if (generarCertificado > -1) {
                const { idsolicitud, idtipocertificado, idpersona, concurrencyToken } = datosVistaPrevia;
                const personaActualFirma = personalFirma[0]
                if (personaActualFirma && personaActualFirma.idpersona !== -1) {
                    GenerarCertificado(datosUsuario, idtipocertificado, {
                        idPersonaCertificado: idpersona,
                        idSolicitudCertificado: idsolicitud,
                        personafirma: personaActualFirma,
                        encabezadodirigido: encabezadoDirigido,
                        concurrencyToken
                    })
                }
                else {
                    ReiniciarModalCertificado()

                    alertService.error(ERRORES_SOLICITUDESCERT_ANALISTAS.generar_certificado_error)
                }
            }
        }
    }, [generarCertificado, encabezadoDirigido])

    useEffect(() => {
        if (urlVistaPrevia !== "") {
            setshowModalVistaPrevia(true);

        }
    }, [urlVistaPrevia])

    useEffect(() => {
        if (loadingSolicEmitidasFirmadas) {
            var elemento: any = (
                <Cargando
                    mensaje='Cargando Certificados Emitidos/Firmados'
                />
            )
            setElementoTablaSolicEmitFirm(elemento);
        }
    }, [loadingSolicEmitidasFirmadas, DataTableSolicitudesEmitidasFirmadas])


    function handlesubirCertificado(datos: DatosVistaPrevia) {

        setdatosVistaPrevia(datos);
    }

    async function HandleChangeAnioTable(anio: number) {
        setanioSeleccionadoConsulta(anio);
    }

    async function handleDescargarCertificado(referencia?: string) {
        if (!referencia) {
            alertService.error("No ha sido posible descargar el certificado");
            return
        }
        else {
            await DescargarCertificado(referencia)
        }
    }




    if (loading) {
        return <Cargando />
    }

    return (
        <div className="content">
            <Container fluid>
                <Row>
                    <Col xl={12}>
                        Solicitudes Certificados
                    </Col>
                </Row>
                {
                    DataTableSolicitudes.length === 0 &&

                    <div className='mt-5'>
                        No hay solicitudes de certificados por administrar actualmente
                    </div>

                }
                {
                    DataTableSolicitudes.length !== 0 &&
                    <Row>
                        <Col xl={12}>
                            <TableSolicitudesCertificadoAnalista
                                dataprops={DataTableSolicitudes}
                                onClickVistaPrevia={(vistaPrevia: DatosVistaPrevia) =>
                                    setdatosVistaPrevia(vistaPrevia)
                                }
                                handleSubirCertificado={(vistaPrevia: DatosVistaPrevia) => handlesubirCertificado(vistaPrevia)}
                                handleDescargarCertificado={(referenciaCertificado: string) => handleDescargarCertificado(referenciaCertificado)}
                                handleNotificarRoles={(idSolicitudCertificado: number) => setdataModalRolesPago({ showModal: true, idSolicitud: idSolicitudCertificado })}
                                anioSeleccionado={anioSeleccionadoConsulta}
                                onChangeYear={async (anioSeleccionado: number) => await HandleChangeAnioTable(anioSeleccionado)}
                                onClickAtender={(vistaPrevia: DatosVistaPrevia) => setdatosModalAtender({ datosCertificado: vistaPrevia })}

                            />
                        </Col>
                    </Row>
                }
                {/* {ElementoTablaSolicEmitFirm} */}
                {
                    <Modal
                        isOpen={showModalloading}
                        scrollable={true}
                        fullscreen={"xl"}
                        centered={true}
                        onClosed={() => setshowModalloading(false)}
                    >
                        <ModalBody>
                            <div><Cargando /></div>
                        </ModalBody>
                    </Modal>
                }
                {
                    datosVistaPrevia.idpersona > 0 &&
                    <ModalVistaPrevia

                        show={showModalVistaPrevia}
                        onClose={() => ReiniciarModalCertificado()}

                        datos={{ url: urlVistaPrevia, ids: datosVistaPrevia }}
                        toogle={() => setshowModalVistaPrevia(!showModalVistaPrevia)}
                        // opcionesFirma={opcionesPersonaFirma}
                        handleSelectChange={(value: string, name: string) => handleSelectChange(value, name)}
                        // opcionFirma={personaFirma.idpersona}
                        // handleActualizarVistaPrevia={() => setactualizarVistaPrevia((prev) => prev + 1)}
                        handleActualizarVistaPrevia={ async () =>  await RecargarVistaPrevia(datosVistaPrevia)}
                        handleEncabezadoDirigido={(valor: string) => setencabezadoDirigido(valor)}
                        handleGenerarCertificado={() => setgenerarCertificado(generarCertificado + 1)}

                    />
                }
                <ModalSubirCertificado
                    show={showModalSubirCertificado}
                    // opcionesFirma={opcionesPersonaFirma}
                    opcionFirma={personalFirma.length > 0 ? personalFirma[0].idpersona : -1}
                    handleSelectChange={(value: string, name: string) => handleSelectChange(value, name)}
                    datos={datosVistaPrevia}
                    toogle={() => setshowModalSubirCertificado(!showModalSubirCertificado)}
                    onClose={() => ReiniciarModalCertificado()}
                    handleSubirCertificado={(datos: SolicitudCertificado) => HandleRespuestaEmitirCrearCertificado(datos, "Se ha generado el Certificado con éxito")}
                />
                <ModalConfirmacion
                    show={dataModalRolesPago.showModal && dataModalRolesPago.idSolicitud > -1}
                    size="md"
                    asyncAccion={true}
                    asyncClose={true}
                    hideBotonCerrar={false}
                    closeAfterAccion={true}
                    mensajeConfirmacion={"Se notificará al servidor que su certificado de roles de pago está disponible"}
                    nombreBotonAccion={"Notificar servidor"}
                    onClose={() => setdataModalRolesPago(defaultStateModalRP)}
                    asyncOnClick={() => handleNotificarCertificado(dataModalRolesPago.idSolicitud)}
                    asyncAfterOnClose={() => ObtenerSolicitudesCertificadosPendientes(authenticationService.currentUserValue, anioSeleccionadoConsulta)}
                    classNameAllModal={'modal-detalle-rolesPago'}
                />
                <ModalAtenderCertificado
                    show={datosModalAtender !== undefined && datosModalAtender.datosCertificado !== undefined}
                    datos={datosModalAtender?.datosCertificado}
                    toogle={() => setdatosModalAtender(undefined)}
                    onClose={() => setdatosModalAtender(undefined)}
                    handleCertificadoAtendido={() => HandleRespuestaAtenderCertificado("La solicitud de certificado ha sido procesada")}

                />
            </Container>
        </div>
    )
}
